export const sortBy = (array: any[] = [], value: string) => {
  return array.slice().sort((a, b) => a && b && a[value] - b[value]);
};
